export { default, ManagerDashboardProductSection } from './ManagerDashboardProductSection';
